import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';

import SiteSettings from 'src/siteSetting';

import FDICHousingLogo from './FDICHousingLogo';
import FDICLogo from './FDICLogo';
import Marquee from './Marquee';

interface Props {
  houseLogoEnabled: boolean;
  isMobile: boolean;
}

export function FDICBannerElement({ houseLogoEnabled, isMobile }: Props) {
  const { palette } = useTheme();

  return (
    <Box
      gap={1}
      height={'48px'}
      style={{
        alignItems: 'center',
        backgroundColor: palette.primary.light,
        display: 'flex',
        flex: 1,
        padding: isMobile ? '0px 0px 0px 20px' : '0px 32px',
      }}
    >
      {houseLogoEnabled && (
        <Box data-test-id="fdic-housing-logo" sx={{ width: '92px' }}>
          <FDICHousingLogo size={92} />
        </Box>
      )}
      <Box data-test-id="fdic-logo" sx={{ width: '45px' }}>
        <FDICLogo />
      </Box>
      {isMobile ? (
        <Box
          sx={{
            width: houseLogoEnabled
              ? 'calc(100vw - 180px)'
              : 'calc(100vw - 90px)',
          }}
        >
          <Marquee
            speed={12}
            text={
              'FDIC-Insured - Backed by the full faith and credit of the U.S. Government'
            }
            typographyStyle={{
              bottom: '2px',
              color: palette.basic.white,
              fontFamily: '"Libre Franklin", sans-serif',
              fontSize: isMobile ? '12px' : '14px',
              fontWeight: 500,
              marginLeft: '16px',
              position: 'relative',
            }}
          />
        </Box>
      ) : (
        <Typography
          sx={{
            color: palette.basic.white,
            fontFamily: '"Libre Franklin", sans-serif',
            fontSize: isMobile ? '12px' : '14px',
            fontWeight: 500,
            height: '20px',
            marginLeft: '16px',
          }}
        >
          FDIC-Insured - Backed by the full faith and credit of the U.S.
          Government
        </Typography>
      )}
    </Box>
  );
}

/* istanbul ignore next */
function FDICBanner() {
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('md'));
  const housingLogoEnabled = SiteSettings.generalHousingLogoEnabled();
  return (
    <FDICBannerElement
      houseLogoEnabled={housingLogoEnabled}
      isMobile={isMobile}
    />
  );
}

export default FDICBanner;
